<template>
  <div>
    <a-modal
       width="600px"
      :centered="true"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      title="Ask a Question"
      v-model="showModal"
      :footer="null"
   
      @ok="() => (showModal = false)"
    >
      <CreateQuestionModal :handleShowModal="handleClose" />
    </a-modal>
  </div>
</template>

<script>
import CreateQuestionModal from "../Modals/CreateQuestionModal.vue";

export default {
  name: "TreatmentQuestionModal",
  components: {
    CreateQuestionModal
  },
  data() {
    return {
      showModal: false
    };
  },

  methods: {
    show(id) {
      this.showModal = true;
    },

    handleClose() {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  height: 100vh;
  overflow-y: hidden;
  padding-right: 15px; /* Avoid width reflow */
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/TreatmentQuestionModal.vue